import { ActionTypes } from "./constants";

export const setTheme = (theme) => {
  return {
    type: ActionTypes.SET_THEME,
    payload: theme,
  };
};

export const setDark = (mode) => {
  return {
    type: ActionTypes.SET_DARK,
    payload: mode,
  };
};

export const getData = (data) => {
  return {
    type: ActionTypes.DATA,
    payload: data,
  };
};

export const getFilteredData = (data) => {
  return {
    type: ActionTypes.FILTERED_DATA,
    payload: data,
  };
};

export const topStories = (data) => {
  return {
    type: ActionTypes.TOP_STORIES,
    payload: data,
  };
};

export const trending = (data) => {
  return {
    type: ActionTypes.TRENDING,
    payload: data,
  };
};

export const popular = (data) => {
  return {
    type: ActionTypes.POPULAR,
    payload: data,
  };
};

export const headlines = (data) => {
  return {
    type: ActionTypes.TOP_HEADLINES,
    payload: data,
  };
};
